/***
 * 描述：系统公共的header部分
 */
import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  ComponentFactoryResolver,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { SwMenuService } from "src/app/librarys/serves/sw-menu.service";
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
import { Router, NavigationEnd, ActivationEnd } from "@angular/router";
import { SwPersonViewComponent } from "../sw-person-view/sw-person-view.component";
import { SwSwitchUserComponent } from "../sw-switch-user/sw-switch-user.component";
import { SwChangePasswordComponent } from "../sw-change-password/sw-change-password.component";
import { SwLockSystemComponent } from "../sw-lock-system/sw-lock-system.component";
import { GetUserModelService } from "src/app/librarys/serves/public/get-user-model.service";
import { ProcessToDosService } from "src/app/librarys/serves/public/process-to-dos.service";
import { OninitService } from "src/app/librarys/serves/oninit.service";
import { SwHttpClientService } from "src/app/librarys/serves/sw-http-client.service";
import { environment } from "src/environments/environment";
import { SwMassageBoxService } from "src/app/librarys/serves/sw-massage-box.service";
import { SwWebSocketService } from "src/app/librarys/serves/sw-web-socket.service";
import { SwSimpleReuseStrategy } from "src/app/librarys/serves/sw-simplereusestrategy";
import { ConfigurationService } from "src/app/librarys/serves/public/configuration.service";
import { SystemIdService } from "src/app/librarys/serves/public/system-id.service";
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { BdpEnum } from "src/app/areas/bdp/serves/bdp-enum";
import { SwUnfocusGuardService } from '../../librarys/serves/sw-unfocus-guard.service'
import { PlatformLocation } from "@angular/common";
import { SwHeaderNoticeComponent } from "./sw-header-notice/sw-header-notice.component";
import { SwTabService } from "src/app/librarys/serves/public/sw-tab.service";
import { SwRouteguardService } from "src/app/librarys/serves/sw-routeguard.service";
import { KmsService } from "src/app/areas/kms/kms.service";
declare var $: any;
@Component({
  selector: "sw-header",
  templateUrl: "./sw-header.component.html",
  styleUrls: ["./sw-header.component.css"]
})
export class SwHeaderComponent implements OnInit,OnDestroy {

  SkinColor: any[] = []; //皮肤颜色信息
  menuList: any[] = []; //菜单
  systemData: any = []; //所属系统
  miniLogo: any =''; // mini  logo
  projectLogo: any; //头部左侧背景图片路径
  projectLogoWidth: string = '' //项目logo的宽度
  isToggle: boolean = false; //是否向左折叠
  singleMenu: boolean = false; //头部是否用所有门户替换一级菜单
  defaultPortal:string = "" //默认首页
  toUrl:string = '' //路由变化时要去的路由地址
  asideMenuSubscriptiona:any  //订阅路由是否从首页离开，如果是，就将头部菜单和侧边栏菜单都刷新成对应模块菜单
  headerRouterSubscriptiona:any  //路由订阅对象
  systemSubscriptiona:any  //系统数据订阅对象
  // processSubscriptiona:any  //待办数据订阅对象
  areasSubscriptiona:any  //模块菜单数据订阅对象
  noticeSubscriptiona:any  //通知数据订阅对象
  isEnUs:boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
  isSwitchSkin: boolean = true; //头部是否可以切换项目皮肤
  constructor(
    private Areas: SwMenuService, //请求菜单服务
    private router: Router, //路由服务
    private config: ConfigurationService, //初始化配置文件
    private http: SwHttpClientService, //http 请求服务
    private box: SwMassageBoxService, //提示框服务
    private process: ProcessToDosService, //流程待办服务
    private User: GetUserModelService, //获取用户服务
    private swJwtService: SwJwtService, //浏览器缓存服务
    private jwt: SwJwtService,
    private system: SystemIdService, //写入systemid
    private websoket: SwWebSocketService,
    private init: OninitService, //初始化服务方法
    private el: ElementRef, //获取dom元素
    private create:SwCreateModalComponentService,
    private cfr: ComponentFactoryResolver,
    private swUnfocusGuardService : SwUnfocusGuardService, 
    private Location: PlatformLocation,
    private swtab: SwTabService, //tab 页面服务
    private rot: SwRouteguardService,
    private kmsService: KmsService,
  ) { 
    this.isSwitchSkin = environment.isSwitchSkin; //头部是否可以切换项目皮肤
    this.projectLogo = environment.projectLogo;
    this.projectLogoWidth = environment.projectLogoWidth;
    this.singleMenu = environment.singleMenu;  //头部是否用所有门户替换一级菜单
    this.defaultPortal = environment.defaultPortal  //获取默认首页
    this.headerRouterSubscriptiona = this.router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof ActivationEnd) {  
        //监听路由事件，可以获取到路由变化时要跳转的路由地址
        let path = "";
        for (let i = 0; event.snapshot["_urlSegment"].segments.length > i; i++) {
          if (event.snapshot["_urlSegment"].segments[i].path!="" ) {
            path = path + "/" +event.snapshot["_urlSegment"].segments[i].path
          }
        }
        //更新要跳转的路由地址
        this.toUrl = path
        
        if(path){
          //下面看要不要高亮一级菜单
          let toUrlModal = path.split('/')[1].toLocaleUpperCase()
          //由于一开始默认工作门户没有选中一级菜单，所以在其他时候，路由跳转的时候，如果跳转的页面是工作门户，就还是不要显示一级菜单高亮，否则显示菜单高亮
          //如果跳转的页面跟工作门户是同一个模块，就要定位到模块
          // if(defaultPortalModal == toUrlModal && !environment.defaultPortal.includes(path) && !this.activeFunctionId){
            let avtiveAreasModel = this.AreasModel.filter(item => item.functionCode == toUrlModal)[0]
            if(avtiveAreasModel){
              this.activeFunctionId = avtiveAreasModel.functionId;    
              if(avtiveAreasModel.css == "1"){
                this.activeSecondFunctionId = avtiveAreasModel.children[0].functionId
              }
              this.jwt.setlocaToken('avtiveAreasModel',JSON.stringify(avtiveAreasModel)) 
            }else{
              this.activeFunctionId = null
              this.activeSecondFunctionId = null
            }
            // else if(this.AreasModel.length){
            //   //菜单区域是默认加载第一个模块的工作台,所以模块区域每次刷新页面的时候,默认加载一个模块
            //   this.activeFunctionId = this.AreasModel[0].functionId;
            //   //如果第一个就是数据中心,那么数据中心下的第一个二级菜单需要高亮
            //   if(this.AreasModel[0].css == "1"){
            //     this.activeSecondFunctionId = this.AreasModel[0].children[0].functionId
            //   }
            //   this.jwt.setlocaToken('avtiveAreasModel',JSON.stringify(this.AreasModel[0]))
    
            // }
            // else if(environment.defaultPortal.includes(path)){
            //   //如果就是跳转到工作门户，就不显示一级模块高亮
            //   this.activeFunctionId = null 
            //   this.activeSecondFunctionId = null
            // }
        }
      }
    });
    //isEnUs:boolean = false; //当前语言是否为英文English 是英文为true  不是英文（是中文）为false
    let currLanguage = this.jwt.getToken('language')
    if(currLanguage == 'en-US'){
     this.isEnUs = true
    }else {
      this.isEnUs = false
    }
    //admin时，监听系统数据变化
    this.systemSubscriptiona = this.system.systemNameChanged.subscribe((data)=>{
       if(data){
          //获取所有的系统消息(登录用户是admin时才需要)
          this.getSystemData();
       }
    })
  }

  // WordFlow: any = []; //待办数据
  systemName: string = "" //系统logo
  systemIco: string = "" //图标
  showAreasList: any[] = []; //能够显示的菜单数据
  moreAreasList: any[] = []; //下拉中的菜单的数据
  activeFunctionId: string; //当前高亮菜单
  availableSpace: any; //ul的可用的宽度
  numOfVisibleItems: any; //可展示的菜单数量
  requiredSpace: any; //可展示需要的长度
  breakWidth: any[] = []; //所有菜单展示宽度区间
  WebSokets: any ;  //消息队列
  activeSystemId:string = ""  //当前展示的系统
  activeSkinColor:string = ""  //当前皮肤
  activeProjectName:string  //当使用admin登录的时候,有切换系统,在页面上显示切换之后的名称
  activeMenu:any=null;  //当鼠标移入到 css 为1 的一级菜单中,根据此属性将更多的二级菜单显示出来
  activeSecondFunctionId:string  //点击的一级菜单所属的二级菜单高亮的functionId
  gender:any  //当前用户的性别
  position: any //当前用户主岗信息
  proWidth:string = '220px'  //左侧logo宽度
  singleTab:boolean = false  //是否为单页签模式
  fullScreen:boolean = false //是否所有页面都全屏
  @Output() emitToggle = new EventEmitter(); //抛出事件
  @Output() emitQuickMenuClick = new EventEmitter(); //抛出事件
  detail: any = {}
   //用户常用头像
   userImage: any = []
  ngOnDestroy(): void {
    if(this.asideMenuSubscriptiona){
      this.asideMenuSubscriptiona.unsubscribe()  //取消订阅--侧边栏菜单数据
    }
    if(this.headerRouterSubscriptiona){
      this.headerRouterSubscriptiona.unsubscribe()  //取消订阅--路由对象
    }
    if(this.systemSubscriptiona){
      this.systemSubscriptiona.unsubscribe()  //取消订阅--系统数据
    }
    // if(this.processSubscriptiona){
    //   this.processSubscriptiona.unsubscribe()  //取消订阅--待办数据
    // }
    if(this.areasSubscriptiona){
      this.areasSubscriptiona.unsubscribe()  //取消订阅--模块菜单
    }
    if(this.noticeSubscriptiona){
      this.noticeSubscriptiona.unsubscribe()  //取消订阅--通知消息
    }
  }
  // 是否显示快捷菜单
  showQuickMenu = true;
  // 切换知识库请求头部
  headers:any = {}
  // 当前知识库id
  kgDbId:string = '';
  // 知识库可选项
  kgOptions:any = [];
  // 刷新知识库选项定时器
  t:any;
  // 知识库状态 loading:切换中；fail:失败
  state = 'loading'
  failTip = '';

  ngOnInit() {
  //this.inItConfig();
    this.userImage = this.User.getUserImage()
    this.initValue();
    this.singleTab = environment.singleTab  //是否为单页签模式
    this.fullScreen = environment.fullScreen == '*' //是否所有页面都全屏 ， 当为单页签模式且所有页面都全屏时，鼠标浮到一级菜单上，展示级联面板中的子级菜单
    //皮肤颜色:
    this.SkinColor = [
      // {className:'skin-default',des:'默认',baseColor:'#00c0ef'},
      { className: "skin-blue", des: "蓝",desEn: "Blue", baseColor: "#00c0ef" ,leftColor:"#242a2e",topColor:"#00c0ef",leftTopColor:"#1090a5"},
      { className: "skin-blue-dark", des: "蓝-深",desEn: "Blue-dark", baseColor: "#00c0ef",leftColor:"#242a2e",topColor:"#181c1e",leftTopColor:"#010202", active: true },
      { className: "skin-blue-light", des: "蓝-浅",desEn: "Blue-light", baseColor: "#00c0ef",leftColor:"#f9fafc",topColor:"#00c0ef",leftTopColor:"#1090a5" },
      { className: "skin-green", des: "绿",desEn: "Green", baseColor: "#18bc9c",leftColor:"#242a2e",topColor:"#18bc9c" ,leftTopColor:"#128f76"},
      { className: "skin-green-dark", des: "绿-深",desEn: "Green-dark", baseColor: "#18bc9c" ,leftColor:"#242a2e",topColor:"#181c1e",leftTopColor:"#010202"},
      { className: "skin-green-light", des: "绿-浅",desEn: "Green-light", baseColor: "#18bc9c" ,leftColor:"#f9fafc",topColor:"#18bc9c",leftTopColor:"#128f76"},
      { className: "skin-red", des: "红",desEn: "Red", baseColor: "#e74c3c" ,leftColor:"#242a2e",topColor:"#e74c3c",leftTopColor:"#d62c1a"},
      { className: "skin-red-dark", des: "红-深",desEn: "Red-dark", baseColor: "#e74c3c" ,leftColor:"#242a2e",topColor:"#181c1e",leftTopColor:"#010202"},
      { className: "skin-red-light", des: "红-浅",desEn: "Red-light", baseColor: "#e74c3c" ,leftColor:"#f9fafc",topColor:"#e74c3c",leftTopColor:"#d62c1a"},
      { className: "skin-yellow", des: "黄",desEn: "Yellow", baseColor: "#f39c12" ,leftColor:"#242a2e",topColor:"#f39c12",leftTopColor:"#c87f0a"},
      { className: "skin-yellow-dark", des: "黄-深",desEn: "Yellow-dark", baseColor: "#f39c12" ,leftColor:"#242a2e",topColor:"#181c1e",leftTopColor:"#010202"},
      { className: "skin-yellow-light", des: "黄-浅",desEn: "Yellow-light", baseColor: "#f39c12" ,leftColor:"#f9fafc",topColor:"#f39c12",leftTopColor:"#c87f0a"},
      { className: "skin-default-dark", des: "默认-深",desEn: " Default-dark", baseColor: "#e74c3c" ,leftColor:"#f9fafc",topColor:"#181c1e",leftTopColor:"#010202"},
      { className: "skin-default", des: "默认",desEn: " Default", baseColor: "#3DBC8E" ,leftColor:"#fffff",topColor:"#ffffff",leftTopColor:"#ffffff"}
    ];
    this.detail.fax = this.userImage[0]
    //获取用户信息
    this.UserModel = this.User.getUser();
    if(this.UserModel==null){
      //用户信息没获取到之前直接返回
      this.UserModel={};
      return false;
    }
    this.position = JSON.parse(this.jwt.getToken('position'))
    //获取用户性别,根据性别决定头像
    this.gender = this.UserModel['userDetail']['gender'] 
    this.getUserDetailById()
    /* //获取待办数据
    this.process.oninitToDoToDos()  //获取前五条待办
    if (this.process.processList) {
      this.WordFlow = this.process.processList;
    }
    //订阅待办数据
    this.processSubscriptiona = this.process.processUpdated.subscribe(val => {
      this.WordFlow = val;
    }); */
    //获取所有通知信息
    this.GetWebSoketList();

    //获取前五条消息,在 websocket服务中的 onopen 里面就不使用 message/sendMessage 来获取所有的消息了,将之注释掉
    this.process.oninitNotice()
    if(this.UserModel.userId == 1 || this.UserModel.loginName == 'admin'){
      //获取所有的系统消息(登录用户是admin时才需要)
      this.getSystemData();
    }

    //获取皮肤(最开始缓存中没有皮肤,直接从body标签的类中获取)
    this.activeSkinColor = this.jwt.getlocaToken("skinColor")
    if(!this.activeSkinColor){
      let classList = this.el.nativeElement.offsetParent.classList
      classList.forEach(skin => {
        if(skin.indexOf('skin-') != -1){
          this.activeSkinColor = skin
        }
      });
    }

    // 查询待提取资源数量
    this.queryResourceNumToZstq();
  }
  //根据当前登录用户 获取该用户的基本个人信息
  getUserDetailById(){
    //请求参数
    let Params = { ids: [this.UserModel.userId] }
    //请求数据获取用户基础数据
    this.http.Post(environment.seekerWebAPI + "user/queryById", Params).subscribe(
      data => {
        if(data['code'] == 200){
          this.UserModel.displayName = data["data"].displayName
          //用户基础信息
          this.detail = data["data"]["userDetail"]
          if(!this.detail.fax){
            this.detail.fax = this.userImage[0]
          }
          // 获取当前用户的角色信息
          let roleList = data['data']['roleList'];
          // 判断是否为超级管理员
          let orgId = '';
          if(roleList && roleList.filter(item => item.roleCode == 'KGS_SWHT_ADMIN').length > 0){
            this.jwt.setToKen('userRole','超级管理员');
            this.showQuickMenu = false;
            orgId = 'all';
          }else if(roleList && roleList.filter(item => item.roleCode.indexOf('_ZSK_ADMIN')>=0).length > 0){
            this.jwt.setToKen('userRole','知识库管理员');
          }else if(roleList && roleList.filter(item => item.roleCode.indexOf('_CONFIG_ADMIN')>=0).length > 0){
            this.jwt.setToKen('userRole','配置管理员');
          }else if(roleList && roleList.filter(item => item.roleCode.indexOf('_EDITOR')>=0).length > 0){
            this.jwt.setToKen('userRole','知识编辑');
          }else if(roleList && roleList.filter(item => item.roleCode.indexOf('_AUDITOR')>=0).length > 0){
            this.jwt.setToKen('userRole','知识质检');
          }else{
            this.jwt.setToKen('userRole','其他');
            this.showQuickMenu = false;
          }
          this.projectLogo = environment.projectLogo;
          this.projectLogoWidth = environment.projectLogoWidth;
          this.headers= {
            'Content-Type' :'application/json',
            'Accept':'application/json',
            'authorizationu': this.system.getSystemId()
          };
          if(roleList.length>0){
            // 默认加载第一个知识库
            let orgIds = orgId == 'all' ? [] : [roleList[0].orgId];
            this.jwt.setToKen('orgId',roleList[0].orgId);
            // 触发刷新知识库选项定时器
            this.refreshKgDbs();
            // 获取知识库信息，并默认切换至第一个
            this.getKgDbInfo(orgIds);
          }else{
            $('#swMask1').addClass('maskShow');
            this.failTip = '当前用户未绑定任何角色';
            this.state = 'fail';
          }
        }
      }
    )
  }

  // 刷新知识库选项
  refreshKgDbs(){
    this.t = setInterval(()=>{
      // 知识库绑定组织、知识库删除操作会触发刷新操作
      let isRefresh = this.jwt.getToken('isRefreshKgDbs');
      if(isRefresh && isRefresh=='true'){
        this.jwt.setToKen('isRefreshKgDbs','false');
        let userRole = this.jwt.getToken('userRole');
        let orgId = [this.jwt.getToken('orgId')];
        if(userRole == '超级管理员'){
          orgId = [];
        }
        // 获取该组织关联的所有知识库
        this.http.Post(environment.kgsBasicApi + "knowledgebase/queryByOrgId",orgId,this.headers).subscribe(
          result => {
            if(result['code'] == 200){
              if(result.data && result.data.length > 0){
                let kgOptions = result.data;
                kgOptions.forEach(element => {
                  element['id'] = element['kgDbId'];
                  element['text'] = element['knowledgebaseName']
                });
                this.jwt.setToKen("kgDbs",JSON.stringify(kgOptions));
                this.kgOptions = kgOptions;
                // 判断当前用户是否仍具有对该知识库的操作权限
                let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
                let tenantId = kgDbInfo && kgDbInfo.kgDbId ? kgDbInfo.kgDbId : '';
                let len = kgOptions.filter(item => item.id == tenantId).length;
                // 无权限
                if(len == 0){
                  // 判断当前用户是否存在有权限的知识库，存在则默认加载第一个；否则，清除缓存中的知识库信息
                  if(kgOptions.length>0){
                    // 修改tenantId参数
                    this.jwt.setToKen('kgDbInfo',JSON.stringify(kgOptions[0]));
                    this.kgDbId = kgOptions[0].kgDbId;
                    // 获取工作门户页面路由
                    let consolePage = '/kms/KmsConsole';
                    // 刷新工作门户页面
                    this.router.navigate([consolePage], {queryParams: {Title: '控制台'}});
                    this.swtab.refurbis(consolePage);
                    // 关闭其他tab选项卡
                    setTimeout(()=>{
                      let menus = this.rot.getMenus();
                      menus.forEach(item => {
                        if(item.path != consolePage){
                          this.swtab.closeUrl(item.path);
                        }
                      });
                    },200);
                  }else{
                    this.jwt.setToKen('kgDbInfo',JSON.stringify({}));
                    this.kgDbId = '';
                  }
                }
              }
            }
          }
        )
      }
    },1000);
  }

  //是否向左折叠
  clickToggle(){
    this.isToggle = !this.isToggle
    this.emitToggle.emit(true)
    this.getProjectLogoWidth()
    //还要修改菜单的宽度，由于收起，展开的动画效果要300毫秒，所以要在这段时间不断修改宽度，避免菜单遮盖右侧
    let second = 0
    let timer = setInterval(()=>{
      second+=20
      if(!this.singleMenu){
        this.check() 
      }
      if(second >= 300){
        clearInterval(timer)
      }
    },20)
  }
  //获取项目图片的宽度
  getProjectLogoWidth() {
    //若为向左折叠状态
    if(this.isToggle){
      this.proWidth = '50px'
    }else {
      let wid = parseInt(this.projectLogoWidth);
      this.proWidth = wid + 'px'
      if(!this.singleMenu){
        setTimeout(() => {
          this.check()
        }, 300);
      }
    }
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getProjectLogoWidth()
    }, 0);
    this.asideMenuSubscriptiona = this.swUnfocusGuardService.asideMenuUpdated.subscribe(data=>{
      //监听路由变化时，是否是从首页离开的
      //此时还不知道要跳转到哪里去，先将要去的地址清空
      this.toUrl = ""
      let interval = setInterval(()=>{
        //侧边栏当前菜单信息
        let a = this.Areas.getMenusVal()
        if(this.toUrl){
          if(environment.fullScreen.indexOf(this.toUrl)>-1 || environment.fullScreen == '*'){
            //配置文件里有的全屏页面，
            clearInterval(interval);
            return false;
          }
          let urlArr = this.toUrl.split('/')
          let functionCode = urlArr[1].toLocaleUpperCase()
          if(a.functionCode && functionCode == a.functionCode){
            //如果侧边栏与要去的菜单属于同一个模块，就什么都不做
          } else {
            //如果已经知道了要跳转到哪里去，就可以更新对应的一级模块和侧边栏菜单数据
            //根据要跳转的路径得到对应的模块
            this.AreasModel.forEach(area => {
              if(area.css != 1 && area.functionCode == functionCode){
                this.ClickAreas(area,area.css,true)
              }
              if(area.css == 1 && area.children.length){
                area.children.forEach(child => {
                  if(child.css != 1 && child.functionCode == functionCode){
                    this.ClickAreas(child,child.css,true)
                  }
                });
              }
            });

          }
          
          //清除定时器
          clearInterval(interval)
        }
      },10)
    })
    //获取模块信息
    this.areasSubscriptiona = this.Areas.areasUpdated.subscribe(val => {
      this.AreasModel = this.Areas.getAreasVal(); //所有菜单模块信息
      this.menuList = JSON.parse(this.swJwtService.getToken("TabMenu"));
      /* if (this.menuList != null) {  //每次刷新页面的时候,tab栏都会跳转到工作台,但是模块菜单可以没有对应的,所以直接不显示高亮,注释掉
        let menu = this.menuList.filter(item => item.isSelect == true)[0]; //获取当前显示的路径是属于哪个模块的
        let index1 = menu.path.indexOf("/"); //  /bdp/WatermarkQuery
        let index2 = menu.path.indexOf("/", index1 + 1);
        let str = menu.path.slice(index1 + 1, index2);
        this.AreasModel.forEach(area => {
          if (area.functionCode.toLocaleLowerCase() == str) {
            this.activeFunctionId = area.functionId;
          }
        });
      } */
      let path = this.Location["location"].hash.split('?')[0].split("/");
      //不同模块单点登录功能
      let avtiveIndex = this.AreasModel.findIndex(v=>v.active)
      let SSOFunctionCode = avtiveIndex > -1 ? this.AreasModel[avtiveIndex]['functionCode'] : ''
      if(path.length >= 3 || SSOFunctionCode){
        let areaKey = SSOFunctionCode || path[1].toUpperCase()
        //匹配当前路由对应的菜单模块
        let avtiveAreasModel = this.AreasModel.filter(item => item.functionCode == areaKey)[0]
        if(avtiveAreasModel){
          //如果菜单是默认工作门户，当header部分有一级菜单就是工作门户，就要显示高亮，如果没有就不显示高亮
          let url = this.Location["location"].hash.split('?')[0]
          url = url.replace('#','')
          if(url && environment.defaultPortal.includes(url)){ 
            let pathArr = url.split('/')
            let functionCode = ''
            if(pathArr && pathArr.length >= 2){
              functionCode = pathArr[1].toLocaleLowerCase()   //找到路由中的菜单编号
            }
            let avtiveAreasModel = this.AreasModel.filter(item => item.functionCode.toLocaleLowerCase() == functionCode)
            if(avtiveAreasModel && avtiveAreasModel.length){
              this.activeFunctionId = avtiveAreasModel[0]['functionId']    //如果是首页，还是要高亮一级菜单的
            } else {
              this.activeFunctionId = null
            }
          } else {
            this.activeFunctionId = avtiveAreasModel.functionId;    
            if(avtiveAreasModel.css == "1"){
              this.activeSecondFunctionId = avtiveAreasModel.children[0].functionId
            }
          }
          this.jwt.setlocaToken('avtiveAreasModel',JSON.stringify(avtiveAreasModel))     
        }    
      }else {
        //如果菜单是默认工作门户，当header部分有一级菜单就是工作门户，就要显示高亮，如果没有就不显示高亮
        let url = this.Location["location"].hash.split('?')[0]
        url = url.replace('#','')
        if(environment.defaultPortal.includes(url)){ 
          let pathArr = url.split('/')
          let functionCode = ''
          if(pathArr && pathArr.length >= 2){
            functionCode = pathArr[1].toLocaleLowerCase()   //找到路由中的菜单编号
          }
          let avtiveAreasModel = this.AreasModel.filter(item => item.functionCode.toLocaleLowerCase() == functionCode)
          if(avtiveAreasModel && avtiveAreasModel.length){
            this.activeFunctionId = avtiveAreasModel[0]['functionId']    //如果是首页，还是要高亮一级菜单的
          } else {
            this.activeFunctionId = null
          }
        } else {
          //默认加载第一模块
          //菜单区域是默认加载第一个模块的工作台,所以模块区域每次刷新页面的时候,默认加载一个模块
          this.activeFunctionId = this.AreasModel[0].functionId;
          //如果第一个就是数据中心,那么数据中心下的第一个二级菜单需要高亮
          if(this.AreasModel[0].css == "1"){
            this.activeSecondFunctionId = this.AreasModel[0].children[0].functionId
          }
        }
        //将header中的当前菜单存入本地缓存
        this.jwt.setlocaToken('avtiveAreasModel',JSON.stringify(this.AreasModel[0]))
      }
      
     

      let user = this.User.getUser();
      /* this.AreasModel.forEach(a => {
        //请求加载数据,分两种情况，异步和非异步
        a.aycUrl=environment.seekerWebAPI + "function/queryFunctionsByUserId?parentId=" + a.functionId +"&lazy=true&depth=1"+
        "&systemId=" + this.system.getSystemId() + "&type=1" + "&userId=" + user["userId"];
      }); */
      this.showAreasList = this.AreasModel; //最开始默认展示全部菜单
      setTimeout(()=>{
        $('.area0').trigger('click');
      },0);
    });
    if(this.singleMenu){
      // 如果只显示所有门户这个菜单，就不调用 this.check()
    } else {
      var timer = setInterval(() => {
        //设置定时器来获取dom元素
        if (this.el.nativeElement.querySelectorAll(".area").length != 0) {
          let lis = this.el.nativeElement.querySelectorAll(".area");
          let totalSpace = 0;
          for (var k = 0; k < lis.length; k++) {
            totalSpace += parseInt(lis[k].clientWidth);
            this.breakWidth.push(totalSpace); //不同个数菜单展示宽度区间
          }
          this.check(); //刷新菜单
          clearTimeout(timer); //获取到元素之后,清除定时器
        }
      }, 20);
    }

    this.WebSoketList();
    this.activeSystemId = this.system.getSystemId()
  }
  //初始值
  initValue() {
    //客户名称
    this.systemName = environment.customerName;
    this.miniLogo = environment.favoriteIco;
  }

  //模块信息
  AreasModel: any = [];
  //用户信息
  UserModel: any = {};

  //点击选择模块
  ClickAreas(model,css,isFromProtal?) {
    isFromProtal = isFromProtal || false
    let highlightModel = true  //点击的这个模块是否高亮，切换到该模块，如果是跳转到不同站点，打开新页签的话，就不用了
    if(model.target == "SYS0402"){
      //如果是使用新标签页打开,就直接打开新标签页
      if(model.uri){
        window.open(model.uri)
      } else {
        this.box.danger('无跳转路径！')
      }
    } else {
      if(model.uri){
        //如果有地址直接打开页面
        this.router.navigate([model.uri], { queryParams: { Title: model.functionName }});
      }else{
          //没有可以跳转的地址，表示就是普通的模块，比如 视觉资产
          if(environment["enableModuleDeploy"] && (this.activeFunctionId != model.functionId && this.activeSecondFunctionId != model.functionId)){
            //如果是要跳转到oa或者 bdp 不管是否是分站点部署，都不用开新页签
            if(model.functionCode.toLocaleLowerCase() == 'oa' || model.functionCode.toLocaleLowerCase() == 'bdp'){
              //使用默认方式打开
              this.Areas.setMenusVal(model,isFromProtal,false);
            } else {
              //点击的模块需要在不同站点打开，且点击的是不当前高亮菜单，就要在配置中找到对应的站点，新页签打开此新地址
              let sites = environment["moduleSites"]
              if(sites){
                let site = JSON.parse(sites)[model.functionCode.toLocaleLowerCase()]
                
                //看配置的站点信息中有没有参数
                let SSOQueryParams = {Title:''}  //要跳转的模块的首页名称
                let RedirectUrl = ""  //要跳转的模块的首页路径
                let siteInfo = site.split('?')
                if(siteInfo.length >=2){  //如果有站点信息
                  site = siteInfo[0]    //单纯的站点,不带参数的
                  let pArr = siteInfo[1].split('&')
                  pArr.forEach(v => {
                    let objArr = v.split('=')
                    if(objArr[0] == 'RedirectUrl'){
                      RedirectUrl = objArr[1]
                    } else {
                      SSOQueryParams[objArr[0]] = objArr[1]
                    }
                  });
                }
                if(site){
                  let path = this.Location["location"].href  //当前地址栏站点如果跟要跳转的站点一样，就不打开新页签
                  if(path.indexOf(site) > -1){  //当前地址栏站点如果跟要转转的站点一样，就不打开新页签
                    this.Areas.setMenusVal(model,isFromProtal,false);
                  } else {
                    //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                    
                    let newUri = site + '#/login?functionCode='+model.functionCode
                    let token = this.jwt.getlocaToken('token')
                    let systemId = this.jwt.getlocaToken('systemId')
                    highlightModel = false   //不用切换模块高亮了
                    window.open(newUri+'&token='+token+'&systemId='+systemId+'&RedirectUrl='+RedirectUrl+'&queryParams='+JSON.stringify(SSOQueryParams))  //用不同的站点打开不同的模块

                  }
                } else {
                  this.box.danger('缺少该模块站点配置项')
                }
              } else {
                this.box.danger('缺少站点配置项')
              }


            }
  
          } else {
            //使用默认方式打开
            this.Areas.setMenusVal(model,isFromProtal,false);
          }

      }
     
      if(highlightModel){
        //修改本地缓存的当前一级菜单
        this.jwt.setlocaToken('avtiveAreasModel',JSON.stringify(model))
        //yjs修改的以下部分,点击切换模块初始化tab菜单栏数据 menuList ...
        if(css == "1"){
          //如果css存在,且为1,表示该一级菜单时鼠标悬浮展示更多的菜单样式,类似于郑州的数据中心菜单,这种情况下,要显示点击的高亮样式
          //点击的菜单本身高亮
          this.activeSecondFunctionId = model.functionId 
          //所属一级菜单也要高亮
          this.activeFunctionId = model.parentId  
        } else {
          //没有二级菜单需要高亮
          this.activeSecondFunctionId = null
          //如果只是一般的一级菜单,就直接显示一级菜单的高亮
          this.activeFunctionId = model.functionId; 
        }

      }

    }
  }

  //点击个人信息
  ClickPerson() {
    //打开个人信息页面
    // this.personView.ClickLoca();
    this.create.createModal(SwPersonViewComponent,{})
  }

  //获取所有的系统
  getSystemData() {
    //请求数据
    this.http.Post(environment.seekerWebAPI + "sw/querySystems", {}).subscribe(
      data => {
        if (data["code"] == 200) {
          let active = this.system.getSystemId()
          this.systemData = data["data"]
          this.activeProjectName = this.systemData.filter(item => item.systemId == active)[0].systemName
        }

      }
    )
  }
  
  //发布选中的系统
  setSystem(item) {
    this.activeProjectName = item.systemName
    this.activeSystemId = item.systemId
    this.system.setSystemId(item.systemId)
    this.system.systemIdUpdated.next(item.systemId)
  }
  //待办数据
  OutSelectData(event) { 
    //点击查看内容跳转到具体审核页面
    if(event.keyWord && event.businessId && event.url){
      let param = {
        businessKey: event.keyWord + ":" + event.businessId,
        procInstId:event.procInstId,
        projectId:event.projectId
      };
      //接下来判断是用tab页打开还是模态框打开
      if(event.openType == 1){
        //如果打开方式是 tab页 的话
        if(event.url == '/oa/DynamicFormRender'){
          this.router.navigate(['/oa/DynamicFormRender/'+event['formId']], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
        }else {
          this.router.navigate([event.url], { queryParams: { Title: event.flowName, Operate: BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) } });
        }

      } else if(event.openType == 2){ 
        //如果是用模态框打开
        let fact = this.cfr["_factories"]
        //对参数进行处理
        let modalParam = event.params ? JSON.parse(event.params) : {}
        let queryParams = { Title: event.flowName, Operate:BdpEnum.SYS_PROCESS_VERIFY, data: JSON.stringify(param) }
        let params = {param: modalParam,queryParams: queryParams}
        fact.forEach((value:any,key:any)=>{
          if(value.selector == event.url){
            this.create.createModal(key,params)
          }
        })
      } else {
        this.box.danger('没有打开方式'+event.openType)
      }
    }
  }

  //锁定系统
  ClickLockSystem() {

    this.webSoketClose();
    // //清除token
    // this.swJwtService.removeItem("token");
    //打开锁定系统
    // this.lockSystem.ClickLoca();
    this.create.createModal(SwLockSystemComponent,{},this.webSocketOpen.bind(this))
  }

  //切换用户
  ClickSwitchUser() {
    // this.switchUser.ClickLoca();
    this.create.createModal(SwSwitchUserComponent,{})
  }
  //修改密码
  ClickChangePassword() {
    // this.changePassword.ClickLoca();
    this.create.createModal(SwChangePasswordComponent,{})
  }

  //清除二级缓存
  clickResetEhcache() {
    this.http.Post(environment.seekerWebAPI + "common/resetEhcache", {}).subscribe(data => {
      if (data["code"]==200) {
        this.box.success("清除缓存成功")
      } else {
        this.box.danger("清除缓存失败")
      }
    })
  }
  //退出系统
  exit() {
    //请求退出系统
    this.http
      .Post(`${environment.seekerWebAPI}sw/logout`, null)
      .subscribe(r => {
        this.init.GC(); // 清除缓存，工作台和路由复用
        this.router.navigate(["login"]); //跳转到登入页面
        this.box.success("注销系统"); //提示
        // 退出系统后清除定时器
        clearInterval(this.t);
      });
  }

  //查看所有待办信息
  ClickView() {
    this.router.navigate(["/oa/ToDoProcess"], {
      queryParams: { Title: "待办流程" }
    });
  }

  ClickNoitce() {
    this.router.navigate(["/oa/Notice"], {
      queryParams: { Title: "消息提醒" }
    });
  }
  //切换用户
  changeColor(item) {
    let bodyDom = this.el.nativeElement.parentNode.parentNode.parentNode
      .parentNode;
    this.init.changeColor(bodyDom, item);
    //对当前选中样式进行处理
    this.activeSkinColor = item.className
  }

  //窗口缩放的时候,刷新菜单
  @HostListener("window:resize", ["$event"])
  onresize(event) {
    if(!this.singleMenu){
      // 如果要显示足够的菜单就调用check方法
      this.check(); 
    }
  }

  check() {
    this.availableSpace =
      this.el.nativeElement.querySelector("nav").clientWidth -
      this.el.nativeElement.querySelector(".sidebar-toggle").clientWidth -
      this.el.nativeElement.querySelector(".navbar-custom-menu").clientWidth -
      100; //可用区域,将ul-100
    this.el.nativeElement.querySelector(".nav").style.width =
      this.availableSpace + 100 + "px"; //随着窗口改变,设置ul的宽度
    this.numOfVisibleItems = this.showAreasList.length; //展示的菜单个数
    this.requiredSpace = this.breakWidth[this.numOfVisibleItems - 1]; //展示的菜单所需宽度
    if (this.requiredSpace > this.availableSpace) {
      //如果可用空间不够,就将展示的最后一个放进下拉框
      this.numOfVisibleItems -= 1; //可展示的菜单减少一个
      this.showAreasList = this.AreasModel.slice(0, this.numOfVisibleItems); //减少展示菜单
      this.moreAreasList = this.AreasModel.slice(this.numOfVisibleItems); //增加下拉菜单
      this.el.nativeElement.querySelector(".nav").style.overflow = this
        .moreAreasList.length
        ? null
        : "hidden"; //下拉框按钮是否展示
      this.check();
    } else if (this.availableSpace > this.breakWidth[this.numOfVisibleItems]) {
      //如果可用空间足够展示多一个菜单,就将下拉框减少一个,展示的多一个
      this.numOfVisibleItems += 1; //可展示的菜单增加一个
      this.showAreasList = this.AreasModel.slice(0, this.numOfVisibleItems); //增加展示菜单
      this.moreAreasList = this.AreasModel.slice(this.numOfVisibleItems); //减少下拉菜单
      this.el.nativeElement.querySelector(".nav").style.overflow = this
        .moreAreasList.length
        ? null
        : "hidden"; //下拉框按钮是否展示
      this.check();
    }
  }

  //消息队列
  WebSoketList() {
    //获取用户对象
    let userModel = JSON.parse(this.jwt.getToken("User"));
    //获取请求websoket  ,获取所有消息
    const URL = environment.webSoketApi + 'websocket?userId=' + userModel["userId"];
    //额外请求地址 
    const Path = environment.seekerWebAPI + 'message/sendMessage';
    // this.WebSokets =[];
    this.websoket.create(URL,Path).subscribe(msg => {
      let data = JSON.parse(msg["data"]);
      if(data["title"] == "fresh"){
        this.process.oninitProcessToDos();  //重新获取工作台待办列表
      }else{
        // this.WebSokets.push(JSON.parse(msg["data"]))
        this.process.oninitNotice()  //重新获取右上角通知消息
      }
    })
  }

  //关闭websoket连接
  webSoketClose(){
    this.websoket.close()
  }

  //打开websoket连接
  webSocketOpen(){
    this.websoket.open()
    // this.process.oninitNotice()
  }

  //获取之前所有的未读通知
  GetWebSoketList() {
    //获取待办数据
    if (this.process.noticeList) {
      this.WebSokets = this.process.noticeList;
    }
    //订阅通知消息数据
    this.noticeSubscriptiona = this.process.noticeUpdated.subscribe(val => {
      this.WebSokets = val; 
    });
  }

  //点击查看消息
  ClickWebSokets(event) {
    if(event.type == 0){
      //是消息
      if(!event.content){
        // 是其他非工作流的消息
        if(event.messageId && event.url){
          //如果此消息可以点击跳转的话，此时的url是可以带参数的，有Title
          let path = event.url.split('?')
          //获取跳转路径
          let url = path[0]
          // 如果有参数就获取跳转参数
          let paramArr  
          let queryParams = {}
          if(path[1]){
            paramArr = path[1].split('&')
            paramArr.forEach(element => {
              if(element.indexOf('=') != -1){
                let keyValue = element.split('=')
                queryParams[keyValue[0]] = keyValue[1]
              }
            });
          }
          queryParams['Operate'] = BdpEnum.SYS_PROCESS_VIEW
          SwSimpleReuseStrategy.deleteRouteSnapshot(url)
          this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
            if (data["code"] == 200) {
              // 消息更新成功之后，刷新消息的前五条
              this.process.oninitNotice();
              this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
                this.router.navigate([url], {
                  queryParams: queryParams
                });
              })
            }
          })
        } else if(event.messageId){
          //只是单纯的消息，啥都不用做，点击之后将之设置为已读就行
          this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
            if (data["code"] == 200) {
              // 消息更新成功之后，刷新消息的前五条
              this.process.oninitNotice();
            }
          })
        }
      } else{
        //如果存在 content,就可能是 待办或者是过期提醒，都一样的可以跳转
        let content = JSON.parse(event.content)
        if(content.operateType == 'todo' || content.operateType == 'notice' || content.operateType == 'todoOutDatedNotice'){
          //如果该消息跟流程有关,需要审核组件
          let param = {
            businessKey: event.code + ":" + event.businessId,
            procInstId:content.pid,
            projectId:content.projectId
          };
          let flowName = content.flowName
          if(event.openType == 1){
            //如果打开方式是 tab页 的话
            if(event.url == '/oa/DynamicFormRender'){
              SwSimpleReuseStrategy.deleteRouteSnapshot('/oa/DynamicFormRender/'+content['formId'])  //删除路由快照
            }else {
              SwSimpleReuseStrategy.deleteRouteSnapshot(event.url)  //删除路由快照
            }
            //跳转到待办页面 审核
            this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
              this.process.oninitNotice()
              if(event.url == '/oa/DynamicFormRender'){
                this.router.navigate(['/oa/DynamicFormRender/'+content['formId']], {
                  queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
                });
              }else {
                this.router.navigate([event.url], {
                  queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
                });
              }
            })
          } else if(event.openType == 2){
            //如果是用模态框打开
            this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
              this.process.oninitNotice()
              let fact = this.cfr["_factories"]
              //对参数进行处理
              let modalParam = event.params ? JSON.parse(event.params) : {}
              let queryParams = { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
              let params = {param: modalParam,queryParams: queryParams}
              fact.forEach((value:any,key:any)=>{
                if(value.selector == event.url){
                  this.create.createModal(key,params)
                }
              })
            })
            
          } else {
            this.box.danger('没有打开方式'+event.openType)
          }

        }
      }
    } else if(event.type == 1){
      //站内信，什么都不用做
    } else if(event.type == 2){
      //任务，点击可以跳转，但是不用把该消息设置为已读，要在业务把该任务完成后，业务会自己将此消息设置为已读
      if(event.url){
        let path = event.url.split('?')
        //获取跳转路径
        let url = path[0]
        // 如果有参数就获取跳转参数
        let paramArr  
        let queryParams = {}
        if(path[1]){
          paramArr = path[1].split('&')
          paramArr.forEach(element => {
            if(element.indexOf('=') != -1){
              let keyValue = element.split('=')
              queryParams[keyValue[0]] = keyValue[1]
            }
          });
        }
        this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
          this.router.navigate([url], {
            queryParams: queryParams
          });
        })
      }
    }
  }
  
  //初始化配置文件
  inItConfig() {
    try {
      if (this.config.config) {
        this.systemName = this.config.config.find(x => x.configKey == "SYS_CUSTOMER_NAME").configValue;
        this.systemIco = this.config.config.find(x => x.configKey == "SYS_FAVORITE_ICO").configValue;
      } else {
        this.config.configpdated.subscribe(data => {
          this.systemName = data.find(x => x.configKey == "SYS_CUSTOMER_NAME").configValue;
          this.systemIco = data.find(x => x.configKey == "SYS_FAVORITE_ICO").configValue;
        })
      }
    } catch (e) { }
  }

//鼠标移入菜单触发
  menuMouseover(id){
    this.activeMenu=id;
  }
//鼠标移出菜单触发
  menuMouseout(id){
    this.activeMenu=null;
  }

  defaultHomePage:string
  //点击logo跳转到首页
  linkToPortal(){
    this.defaultHomePage = environment.defaultPortal
    this.router.navigate([this.defaultHomePage], {
      queryParams: {Title:'控制台'}
    });
  }

  //鼠标移入菜单触发,浮现级联面板，展示该模块所有子级菜单
  menuMouseover1(event,areasModel){
    if(this.singleTab  && this.fullScreen){
      //如果是单页签模式
      event.stopPropagation()
      //参数 获取该模块下的所有菜单
      //获取当前用户信息
      let user = this.User.getUser();
      //请求加载数据,分两种情况，异步和非异步
      let path=environment.seekerWebAPI + "function/queryFunctionsByUserId?${pid}=${pidValue}" +"&lazy=true&depth=1"+
      "&systemId=" + this.system.getSystemId() + "&type=1" + "&userId=" + user["userId"];
      //如果是配置或者admin进来，则都获取模块下全部菜单
      if(environment.isLoadAllMenu==true || this.jwt.getToken("systemId")=="0546c13470857e36e03f6b2f9ab684d1"){
        path=environment.seekerWebAPI + "function/queryFunctionsByUserId?${pid}=${pidValue}" +
        "&systemId=" + this.system.getSystemId() + "&type=1" + "&userId=" + user["userId"];
      }
      areasModel.asyncUrl = path
    }
  }


  //鼠标移出菜单触发
  menuMouseout1(event,areasModel){
    if(this.singleTab  && this.fullScreen){
      event.stopPropagation()
      return false
    }
  }

  //头部下拉子菜单点击事件
  cascaderVoted(event){
    let Menus = event.data 
    if (Menus.target == "SYS0402") {
      //如果是使用新标签页打开,就直接打开新标签页
      if (Menus.uri) {
        window.open(Menus.uri)
      } else {
        this.box.danger('无跳转路径！')
      }
    } else {
      //默认方式打开
      if (!Menus.uri) {
        return;
      }
      let uri = Menus.uri.toLocaleLowerCase()
      if (uri.indexOf('http://') != -1 || uri.indexOf('https://') != -1) {
        //如果是打开外部链接,项目中没有对应的页面,就使用固定的tab页打开
        //跳到专门的tab页,在tab页中使用iframe标签打开外部链接
        this.router.navigate(['/bdp/ExternalLinks'], {
          queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName, uri: Menus.uri, id: 'externallinks' + Math.random().toString().split(".")[1] },
        });
      } else {
        //默认方式打开,根据路由跳转链接
        this.router.navigate([Menus.uri], {
          queryParams: { Title: this.isEnUs && Menus.functionNameEn ? Menus.functionNameEn : Menus.functionName },
        });
      }
    }
  }

  /**
   * 判断这条消息是否为待办
   * @param item 
   */
  isToDoNotice(item){
    let flag = false  //默认不是待办
    if(item.content){
      flag = item.content.indexOf('todo') >= 0
    }
    return flag
  }

  openRight(){
    let param = {"WebSokets":this.WebSokets,'position':'right'}
    this.create.createModal(SwHeaderNoticeComponent,param)

  }

  // 获取知识库数据并默认切换至第一个知识库
  getKgDbInfo(orgIds){
    $('#swMask1').addClass('maskShow');
    /*
    查询当前用户所属组织的所有可选知识库
    超级管理员需要查询出所有的知识库
    */
    this.http.Post(environment.kgsBasicApi + "knowledgebase/queryByOrgId",orgIds,this.headers).subscribe(
      result => {
        if(result['code'] == 200){
          if(result.data && result.data.length > 0){
            let kgOptions = result.data;
            kgOptions.forEach(element => {
              element['id'] = element['kgDbId'];
              element['text'] = element['knowledgebaseName']
            });
            this.jwt.setToKen("kgDbs",JSON.stringify(kgOptions));
            this.kgOptions = kgOptions;
            // 修改tenantId参数
            this.jwt.setToKen('kgDbInfo',JSON.stringify(kgOptions[0]));
            this.kgDbId = kgOptions[0].kgDbId;
            this.init.inItDictionary(); //初始化字典
          }
          // 将知识库切换为第一个知识库
          $('#swMask1').removeClass('maskShow');
          this.state = 'loading';
          // 关闭加载页面，进入工作门户页面
          this.router.navigate(['/kms/KmsConsole'], {queryParams: {Title: '控制台'}});
          this.swtab.refurbis('/kms/KmsConsole');
          setTimeout(()=>{
            this.swtab.closeUrl('/kms/KmsLoading');
            this.swtab.closeUrl('/oa/portal');
          },0);
        }else{
          this.state = 'fail';
          this.failTip = '知识库切换失败'
        }
      }
    )
  }

  // 切换知识库
  kgDbChange(event){
    let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
    let tenantId = kgDbInfo && kgDbInfo.kgDbId ? kgDbInfo.kgDbId : '';
    // 判断当前知识库是否发生改变，未发生变化时无需进行任何操作
    if(event.id == tenantId){
      return;
    }
    let kgDbInfo1 = this.kgOptions.filter(item => item.id == event.id)[0];
    // 修改tenantId参数
    this.jwt.setToKen('kgDbInfo',JSON.stringify(kgDbInfo1));
    this.init.inItDictionary(); //初始化字典
    // 获取工作门户页面路由
    let consolePage = '/kms/KmsConsole';
    // 刷新工作门户页面
    this.router.navigate([consolePage], {queryParams: {Title: '控制台'}});
    this.swtab.refurbis(consolePage);
    // 关闭其他tab选项卡
    setTimeout(()=>{
      let menus = this.rot.getMenus();
      menus.forEach(item => {
        if(item.path != consolePage){
          this.swtab.closeUrl(item.path);
        }
      });
    },200)
    this.box.success('知识库切换成功！');
  }

  // 快捷菜单操作
  quickMenuClick(state,isEnable){
    if(isEnable){
      this.emitQuickMenuClick.emit(state);
    }
  }

  // 判断是否为知识图谱模块的菜单
  isKgsMenu(name){
    return true;
    // let arr = ['知识图谱数据生产管理系统','知识图谱应用配置管理系统','内容管理系统','系统管理'];
    // if(arr.indexOf(name)>-1){
    //   return true;
    // }else{
    //   return false;
    // }
  }

  // 查询当前用户已选的所有资源
  queryResourceNumToZstq(){
    const params = {
      current: 1,
      size: 1000,
      userId: this.UserModel.userId
    }
    this.kmsService.queryExtractResourceList(params).subscribe((res) => {
      if(res["code"] == "200"){
        const data = res["data"].records;
        $('#selectedResourceNum').text(data.length);
        this.jwt.setToKen("selectedResourceNum",data.length);
      }
    })
  }
}
